import { render, staticRenderFns } from "./InsurancePayers.vue?vue&type=template&id=80ebee90"
import script from "./InsurancePayers.vue?vue&type=script&lang=js"
export * from "./InsurancePayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports